/** Shared UI utilities. */

import { state } from "./state";

let loaderCount = 0;

export function formatBoolean(value: any): any {
  if (value === true || value === "true" || String(value).toLowerCase() === "да") return "да";
  if (value === false || value === "false" || String(value).toLowerCase() === "нет") return "нет";
  return value;
}

export function formatFileLabel(filename: string, isoDate?: string): string {
  if (!isoDate) return filename;
  const d = new Date(isoDate);
  if (isNaN(d.getTime())) return filename;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const h = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${filename}_${y}${m}${day}T${h}${min}`;
}

export function showLoader(msg = "Обработка..."): void {
  loaderCount++;
  const loader = document.getElementById("global-loader") as HTMLElement | null;
  if (loader) {
    const text = loader.querySelector(".loader-text") as HTMLElement | null;
    if (text) text.innerText = msg;
    loader.style.display = "flex";
  }
}

export function hideLoader(): void {
  loaderCount = Math.max(0, loaderCount - 1);
  if (loaderCount === 0) {
    const loader = document.getElementById("global-loader") as HTMLElement | null;
    if (loader) loader.style.display = "none";
  }
}

export function showToast(msg: string, type: "info" | "success" | "error" | "warning" = "info"): void {
  // Системные сообщения собираем в панели на странице администрирования,
  // чтобы не засорять интерфейс массовой загрузки и других страниц.
  const panel = document.getElementById("admin-log-panel");
  const body = document.getElementById("admin-log-body");
  if (panel && body) {
    const entry = document.createElement("div");
    entry.className = `log-entry ${type}`;
    const time = new Date().toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
    entry.textContent = `[${time}] ${msg}`;
    body.appendChild(entry);
    panel.classList.add("visible");
    body.scrollTop = body.scrollHeight;
    // Ограничиваем историю последними 100 записями
    while (body.children.length > 100) {
      body.removeChild(body.firstChild as Node);
    }
    return;
  }

  const div = document.createElement("div");
  div.className = `status ${type}`;
  div.textContent = msg;
  const container = document.querySelector(".container");
  if (container) container.prepend(div);
  setTimeout(() => div.remove(), 4000);
}

export const opDisplayNames: Record<string, string> = {
  "=": "=",
  "!=": "≠",
  ">": ">",
  "<": "<",
  ">=": "≥",
  "<=": "≤",
  between: "диапазон",
  pct_range: "допуск в %",
  in: "в списке",
  overlap: "хотя бы одно",
  contains_all: "все",
};

export const defaultSystemDict: Record<string, string> = {
  req_id: "id Потребность",
  ref_id: "id Запасы",
  title_full_req: "Наименование потребность",
  title_full_ref: "Наименование запасы",
  analog_counts: "Количество аналогов",
  strategy: "Стратегия сопоставления",
  title_req_norm: "Наименование потребность нормализованное",
  title_ref_norm: "Наименование запасы нормализованное",
  group: "Группа продукции",
  group_name: "Группа продукции",
  class: "Класс",
  class_name: "Класс",
  subclass: "Подкласс",
  subclass_name: "Подкласс",
  group_prod: "Группа",
  qty: "Количество (запасы)",
  price: "Цена",
  warehouse: "Склад",
  territory: "Территория",
  qty_required: "Требуемое количество",
  qty_covered: "Покрытое количество",
  qty_shortage: "Недостаток количества",
};

export function getDisplayColumnName(key: string): string {
  const mp = state.colLabels.master_parser[key];
  if (mp) return mp;
  const sv = state.colLabels.sveta_server[key];
  if (sv) return sv;
  return defaultSystemDict[key] || key;
}

/** Dual-list helpers. */
export function dualListMove(
  fromId: string,
  toId: string,
  action: "add" | "remove" | "up" | "down"
): void {
  const from = document.getElementById(fromId) as HTMLSelectElement | null;
  const to = document.getElementById(toId) as HTMLSelectElement | null;
  if (!from || !to) return;

  if (action === "add") {
    Array.from(from.selectedOptions).forEach((opt) => {
      opt.selected = false;
      to.appendChild(opt);
    });
  } else if (action === "remove") {
    Array.from(to.selectedOptions).forEach((opt) => {
      opt.selected = false;
      from.appendChild(opt);
    });
  } else if (action === "up" || action === "down") {
    const opts = Array.from(to.options);
    const selected = opts.filter((o) => o.selected);
    if (selected.length === 0) return;
    if (action === "up") {
      selected.forEach((opt) => {
        const idx = opts.indexOf(opt);
        if (idx > 0) {
          to.insertBefore(opt, opts[idx - 1]);
        }
      });
    } else {
      selected.reverse().forEach((opt) => {
        const idx = opts.indexOf(opt);
        if (idx < opts.length - 1) {
          to.insertBefore(opt, opts[idx + 1].nextSibling);
        }
      });
    }
  }
}

export function dualListGetValues(selectId: string): string[] {
  const sel = document.getElementById(selectId) as HTMLSelectElement | null;
  return sel ? Array.from(sel.options).map((o) => o.value) : [];
}

export function dualListInit(selectId: string, items: string[], selected?: string[]): void {
  const sel = document.getElementById(selectId) as HTMLSelectElement | null;
  if (!sel) return;
  sel.innerHTML = "";
  items.forEach((item) => {
    const opt = document.createElement("option");
    opt.value = item;
    opt.text = item;
    if (selected && selected.includes(item)) opt.selected = true;
    sel.appendChild(opt);
  });
}
